
// Round numbers
export const round = (value: number, decimals: number): number => {
  const multiplier = Math.pow(10, decimals || 0)
  return Math.round(value * multiplier) / multiplier
}

// Get the current unix timestamp (seconds)
export const timestamp = (): number => {
  return round(new Date().getTime() / 1000, 0)
}

// Get device info
export const platform = () => {
  const platform = navigator.platform
  return {
    isApple: /(Mac|iPhone|iPod|iPad)/i.test(platform),
    isMac: /(Mac)/i.test(platform),
    isIOS: /(iPhone|iPod|iPad)/i.test(platform),
    isWindows: /(Win)/i.test(platform)
  }
}

// Get count-down timer from seconds (60s => 1:00)
export const getFormattedCountdown = (seconds: number) => {
  const date = new Date(0)
  date.setSeconds(Math.abs(seconds))
  const timeString = date.toISOString().substr(11, 8)
  return (seconds < 0 ? '+':'') + timeString.replace(/^[0:]+/, '')
}

export const getUserColor = (name: string) => {
  const alphabet = 'abcdefghijklmnopqrstuvxyzæøå'.split('')
  const rgb = name.split('').splice(0,3).map(letter => ((alphabet.indexOf(letter.toLowerCase()) + 1) || 1) / alphabet.length * 255 )
  return 'rgb('+ rgb.join(',') +');'
}